import { RouteRecordRaw } from "vue-router";
import DebugIndex from "../dbg/DebugIndex.vue";
import DebugLayout from "../dbg/DebugLayout.vue";
import DebugFluteFingering from "../views/DebugFluteFingering.vue";
import DebugMusicNote from "../dbg/DebugMusicNote.vue";
import DebugNoteWithFingering from "../dbg/DebugNoteWithFingering.vue";
import DebugMusicPhrase from "../dbg/DebugMusicPhrase.vue";
import PitchDebug from "../dbg/PitchDebug.vue";
import DebugListeningNote from "../dbg/DebugListeningNote.vue";
import DebugPitchOffsetVisualizer from "../dbg/DebugPitchOffsetVisualizer.vue";
import DebugLiveFingering from "../dbg/DebugLiveFingering.vue";
import DebugSustainedNote from "../dbg/DebugSustainedNote.vue";
import SequencePitchMatcherDebug from "../dbg/SequencePitchMatcherDebug.vue";
import DebugSequencedNotePlayer from "../dbg/DebugSequencedNotePlayer.vue";
import DebugSequencedNoteReadingQuestion from "../dbg/DebugSequencedNoteReadingQuestion.vue";

/**
 * Debug routes for component testing and development
 *
 * These routes provide interactive playgrounds for all major components.
 * Should be disabled or removed in production builds.
 */
export const debugRoutes: RouteRecordRaw[] = [
  {
    path: "/dbg",
    name: "DebugIndex",
    component: DebugIndex,
  },
  {
    path: "/dbg",
    component: DebugLayout,
    children: [
      {
        path: "flute",
        name: "DebugFlute",
        component: DebugFluteFingering,
      },
      {
        path: "note",
        name: "DebugMusicNote",
        component: DebugMusicNote,
      },
      {
        path: "note-fingering",
        name: "DebugNoteWithFingering",
        component: DebugNoteWithFingering,
      },
      {
        path: "phrase",
        name: "DebugMusicPhrase",
        component: DebugMusicPhrase,
      },
      {
        path: "pitch",
        name: "PitchDebug",
        component: PitchDebug,
      },
      {
        path: "listening-note",
        name: "DebugListeningNote",
        component: DebugListeningNote,
      },
      {
        path: "pitch-offset-visualizer",
        name: "DebugPitchOffsetVisualizer",
        component: DebugPitchOffsetVisualizer,
      },
      {
        path: "live-fingering",
        name: "DebugLiveFingering",
        component: DebugLiveFingering,
      },
      {
        path: "sustained-note",
        name: "DebugSustainedNote",
        component: DebugSustainedNote,
      },
      {
        path: "sequence-matcher",
        name: "SequencePitchMatcherDebug",
        component: SequencePitchMatcherDebug,
      },
      {
        path: "sequenced-note-player",
        name: "DebugSequencedNotePlayer",
        component: DebugSequencedNotePlayer,
      },
      {
        path: "sequenced-note-reading-question",
        name: "DebugSequencedNoteReadingQuestion",
        component: DebugSequencedNoteReadingQuestion,
      },
    ],
  },
];
